import { produce } from "immer";
import { Actions } from "./actions";
import { isUndefined } from "lodash";

export interface MeterData {
  data: {
    id: string;
    name: string;
    label: string;
    curValue: number;
    timeStamp: string;
  }[];
  lastUpdated: string;
}

export interface KPIData {
  data: {
    id: string;
    name: string;
    timeStamp: string;
    value: number;
  }[];
  lastUpdated: string;
}

export interface LMPData {
  data: {
    location: string;
    price: number;
  }[];
  lastUpdated: string;
}

export interface FuelData {
  data: {
    type: string;
    amount: number;
  }[];
  lastUpdated: string;
}

export interface MorningReportData {
  data: {
    availableCapacity: number;
    forecastedPeakDemand: number;
    surplusCapacity: number;
    yesterdaysPeakDemand: number;
    creationDate: string;
  }[];
  lastUpdated: string;
}

export interface AppState {
  heatmap: { buildings: { id: string; name: string }[]; lastUpdated: string };
  electric: MeterData;
  steam: MeterData;
  water: MeterData;
  solar: MeterData;
  steamKPI: KPIData;
  waterKPI: KPIData;
  price: LMPData;
  fuel: FuelData;
  report: MorningReportData;
  errors: Record<string, string | undefined>;
  reset: boolean;
}

export const initialState: AppState = {
  heatmap: {
    buildings: [],
    lastUpdated: "",
  },
  electric: {
    data: [],
    lastUpdated: "",
  },
  steam: {
    data: [],
    lastUpdated: "",
  },
  water: {
    data: [],
    lastUpdated: "",
  },
  solar: {
    data: [],
    lastUpdated: "",
  },
  steamKPI: {
    data: [],
    lastUpdated: "",
  },
  waterKPI: {
    data: [],
    lastUpdated: "",
  },
  price: {
    data: [],
    lastUpdated: "",
  },
  fuel: {
    data: [],
    lastUpdated: "",
  },
  report: {
    data: [],
    lastUpdated: "",
  },
  errors: {},
  reset: false,
};

const RootReducer = produce(
  (
    draftState: AppState,
    action: { type: string; payload?: Partial<AppState> }
  ) => {
    try {
      switch (action.type) {
        case Actions.UPDATE_DATA: {
          if (isUndefined(action.payload)) break;

          const { errors: newErrors, ...newData } = action.payload;
          const { errors: _, ...oldData } = draftState;

          const newState = { errors: newErrors, ...oldData, ...newData };
          return newState;
        }

        case Actions.RESET_SCREENS:
          return { ...draftState, reset: !draftState.reset };

        default:
          break;
      }
    } catch (e: any) {
      console.error("reducer error: ", e.message);
      throw e;
    }
  },
  initialState
);

export default RootReducer;
